// src/pages/RegisterPage/RegisterPage.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../../components/Button/Button';
import FormInput from '../../components/FormInput/FormInput';
import styles from '../LoginPage/LoginPage.module.css'; // Reuse login styles

const RegisterPage = () => {
    const [username, setUsername] = useState(''); // MODIFIED: from email to username
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState(''); // Local error for password mismatch
    const [isLoading, setIsLoading] = useState(false);

    // Get register function, global error state, and auth state from context
    const { register, error: authError, isAuthenticated, loading: authLoading, setError: setAuthError } = useAuth();
    const navigate = useNavigate();

    // Redirect if user is already logged in
    useEffect(() => {
         if (!authLoading && isAuthenticated) {
            navigate('/');
         }
    }, [isAuthenticated, authLoading, navigate]);

     // Clear errors when component mounts or inputs change
     useEffect(() => {
        setAuthError(null); // Clear global auth error on mount/navigate
        setPasswordError(''); // Clear local password error
    }, [setAuthError]); // Depend on setAuthError to avoid lint warning

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Clear previous errors
        setPasswordError('');
        setAuthError(null); // Clear global auth error before attempt

        // 1. Validate passwords match
        if (password !== confirmPassword) {
            setPasswordError('Passwords do not match.');
            return; // Stop submission
        }

        // 2. Attempt registration via context
        setIsLoading(true);
        try {
            // MODIFIED: pass username to register function
            const result = await register(username, password); 
            // Registration successful!
            // Navigate to login page or show a success message
            alert(result.message || "Registration successful! Please check for an approval email or log in if auto-approved."); // Use message from backend if available
            navigate('/login'); // Redirect to login page
        } catch (error) {
            // Error is set in AuthContext OR handle other potential errors
            console.error("Registration failed from page:", error);
            // AuthContext should handle setting authError, which will be displayed
        } finally {
             setIsLoading(false); // Ensure loading is stopped
        }
    };

    if (authLoading) {
         return <div className={styles.loadingFullScreen}>Loading...</div>; // Consider a more centered loading indicator
    }
    if (isAuthenticated) {
         return null; // Or redirect, though useEffect handles it
    }

    return (
        <div className={styles.authPage}>
            <div className={styles.authCard}>
                <div style={{ padding: '10px 0', textAlign: 'center' }}>
                    <Link to="/" className={styles.authLink}>← Back to Home</Link>
                </div>
                <div className={styles.authHeader}>
                    <h2 className={styles.authTitle}>Register</h2>
                    <p className={styles.authSubtitle}>Create a new account</p>
                </div>

                <div className={styles.authBody}>
                    {passwordError && <div className={styles.errorMessage}>{passwordError}</div>}
                    {authError && <div className={styles.errorMessage}>{authError}</div>}

                    <form onSubmit={handleSubmit}>
                         <FormInput
                            label="Username:" // MODIFIED
                            id="username-register" // MODIFIED: Use unique ID
                            name="username" // MODIFIED
                            type="text" // MODIFIED
                            value={username} // MODIFIED
                            onChange={(e) => setUsername(e.target.value)} // MODIFIED
                            placeholder="Choose a username" // MODIFIED
                            required
                            autoComplete="username" // MODIFIED (standard value for username)
                        />
                        <FormInput
                            label="Password:"
                            id="password-register" // Use unique ID
                            name="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Create a password" 
                            required
                            autoComplete="new-password"
                        />
                        <FormInput
                            label="Confirm Password:"
                            id="confirmPassword"
                            name="confirmPassword"
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm your password"
                            required
                            autoComplete="new-password"
                        />
                        <Button
                            type="submit"
                            variant="primary"
                            fullWidth
                            disabled={isLoading}
                        >
                            {isLoading ? 'Registering...' : 'Register'}
                        </Button>
                    </form>
                </div>

                <div className={styles.authFooter}>
                    <p className={styles.authFooterText}>
                        Already have an account?{' '}
                        <Link to="/login" className={styles.authLink}>
                            Login here
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default RegisterPage;